class _c {
  constructor(name) {
    this.name = name;
  }
  static instance(name) {
    this.i = this.i || new this(name);
    return this.i;
  }
  get() {
    const _cache = sessionStorage.getItem(this.name);
    return JSON.parse(_cache);
  }
  set(i) {
    i = JSON.stringify(i);
    return sessionStorage.setItem(this.name, i);
  }

  remove() {
    return sessionStorage.removeItem(this.name);
  }
}

export let userInfoStorage = new _c('userInfoStorage');
export let authorizationStorage = new _c('authorizationStorage');
export let xTokenStorage = new _c('xTokenStorage');
export let loginRoleStorage = new _c('loginRoleStorage');
